import React, { useState } from 'react';
import { Coins, Sparkles, ArrowRight, X, Loader, Zap } from 'lucide-react';
import { stripeService, CREDIT_PACKS, CREDIT_COSTS } from '../services/stripeService';
import { authManager } from '../managers/AuthManager';
import './CreditPurchaseModal.css';

const FEATURE_LABELS = {
    score_checks: 'Resume Score Checks',
    cover_letters: 'Cover Letter Generation',
    custom_templates: 'Custom Templates'
};

const CreditPurchaseModal = ({ isOpen, onClose, feature, creditBalance = 0, onUpgrade }) => {
    const [loading, setLoading] = useState(null);

    if (!isOpen) return null;

    const featureLabel = FEATURE_LABELS[feature] || feature;
    const creditCost = CREDIT_COSTS[feature] || 0;
    const user = authManager.getCurrentUser();

    const handleBuyPack = async (packId) => {
        if (!user?.email) return;
        setLoading(packId);
        try {
            await stripeService.createCreditCheckoutSession(user.email, packId);
        } catch (err) {
            console.error('Credit checkout error:', err);
            alert(err.message);
            setLoading(null);
        }
    };

    return (
        <div className="credit-modal-overlay" onClick={onClose}>
            <div className="credit-modal glass-panel" onClick={e => e.stopPropagation()}>
                <button className="credit-modal-close" onClick={onClose}>
                    <X size={18} />
                </button>

                <div className="credit-modal-header">
                    <div className="credit-modal-icon">
                        <Coins size={28} />
                    </div>
                    <h2>Buy Credits</h2>
                    <p className="credit-modal-subtitle">
                        You've used all your monthly <strong>{featureLabel}</strong>.
                        Purchase credits to continue using this feature.
                    </p>
                    {creditCost > 0 && (
                        <div className="credit-cost-info">
                            <Zap size={14} />
                            <span>{creditCost} credit{creditCost > 1 ? 's' : ''} per use</span>
                        </div>
                    )}
                </div>

                <div className="credit-balance-display">
                    <span className="balance-label">Your Balance</span>
                    <span className="balance-value">
                        <Coins size={16} />
                        {creditBalance} credit{creditBalance !== 1 ? 's' : ''}
                    </span>
                </div>

                <div className="credit-packs-grid">
                    {CREDIT_PACKS.map((pack) => (
                        <div
                            key={pack.id}
                            className={`credit-pack-card ${pack.bestValue ? 'best-value' : ''}`}
                        >
                            {pack.bestValue && (
                                <div className="best-value-badge">
                                    <Sparkles size={12} /> Best Value
                                </div>
                            )}
                            <div className="pack-credits">
                                <span className="pack-amount">{pack.credits}</span>
                                <span className="pack-unit">credits</span>
                            </div>
                            <div className="pack-price">{pack.price}</div>
                            <div className="pack-per-credit">{pack.perCredit}/credit</div>
                            <button
                                className={`pack-buy-btn ${pack.bestValue ? 'highlighted' : ''}`}
                                onClick={() => handleBuyPack(pack.id)}
                                disabled={loading === pack.id}
                            >
                                {loading === pack.id ? (
                                    <Loader size={16} className="spin" />
                                ) : (
                                    <>Buy <ArrowRight size={14} /></>
                                )}
                            </button>
                        </div>
                    ))}
                </div>

                {onUpgrade && (
                    <div className="credit-modal-footer">
                        <span className="or-divider">or</span>
                        <button className="upgrade-plan-link" onClick={onUpgrade}>
                            Upgrade your plan for more monthly uses
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CreditPurchaseModal;
